import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

const AttorneysResultRow = ({ row }) => (
  <table className="ir-search-table-results sticky-enabled">
    <tbody>
      <tr>
        <td>
          <span className="address-name" dangerouslySetInnerHTML={{ __html: row.attorney.name }} />
          {row.attorney.address &&
            <span style={{ whiteSpace: 'pre-wrap' }}><br />{row.attorney.address}</span>
          }
          {row.attorney.phone &&
            <div>t: {row.attorney.phone}</div>
          }
          {row.attorney.fax &&
            <div>f: {row.attorney.fax}</div>
          }
          {row.attorney.email &&
            <div>{row.attorney.email}</div>
          }
          {row.attorney.lead &&
            <div><em>({row.attorney.lead})</em></div>
          }
          {row.attorney.assigned_date &&
            <div><em>Assigned: {row.attorney.assigned_date}</em></div>
          }
        </td>
        <td>
          representing
        </td>
        <td>
          {row.associated.map((associated, idx) => (
            <p key={idx}>
              <span className="address-name" dangerouslySetInnerHTML={{ __html: associated.name }} />
              {associated.address &&
                <span style={{ whiteSpace: 'pre-wrap' }}><br />{associated.address}</span>
              }
              {associated.phone &&
                <span><br />t: {associated.phone}</span>
              }
              {associated.fax &&
                <span><br />f: {associated.fax}</span>
              }
              {associated.email &&
                <span><br />{associated.email}</span>
              }
              {associated.role &&
                <em><br />({associated.role})</em>
              }
            </p>
          ))}
        </td>
      </tr>
    </tbody>
  </table>
);

AttorneysResultRow.propTypes = {
  row: PropTypes.any.isRequired,
};

export default AttorneysResultRow;



// WEBPACK FOOTER //
// ./src/components/advancedSearch/results/rows/AttorneysResultRow.jsx